<template>
  <div class="is-vertical-center">
    <div class="form">
      <img class="logo" src="/home/images/logos/logo_white.png" />
      <h1 class="title">
        {{ $t("login.welcome") }} <span>{{ $t("login.home") }}</span>
      </h1>

      <div class="formContent">
        <div class="formElement">
          <label>{{ $t("login.email") }}</label>
          <input :placeholder="$t('login.email')" type="text" v-model="email" />
        </div>
        <div class="formElement">
          <label>{{ $t("login.password") }}</label>
          <p class="recoverPassword">
            <a href="#">
              <router-link to="/recover">{{
                $t("login.forgotPassword")
              }}</router-link>
            </a>
          </p>
          <input
            :placeholder="$t('login.password')"
            type="password"
            v-model="password"
          />
        </div>
      </div>

      <p class="error" v-if="error">{{ $t("login.error") }}</p>

      <button
        v-bind:class="{ buttonDisabled: !isFormValid }"
        :disabled="!isFormValid"
        v-on:click="signIn"
      >
        {{ $t("login.login") }}
      </button>

      <p class="noAccount">
        {{ $t("login.noAccount") }}
        <span
          ><router-link to="/register">{{
            $t("login.register")
          }}</router-link></span
        >
      </p>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import { EventBus } from "../../util/event-bus";

export default {
  name: "login",
  data: function () {
    return {
      email: "",
      password: "",
      error: false,
    };
  },

  computed: {
    isFormValid: function () {
      return (
        this.email.length > 0 &&
        this.password.length > 0 &&
        this.checkEmail(this.email)
      );
    },
  },

  methods: {
    checkEmail: function (email) {
      // eslint-disable-next-line
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    signIn: function () {
      this.error = false;
      EventBus.$emit("showLoading");

      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          (auth) => {
            let user = auth.user;

            //CHECK VERSION
            this.$store.dispatch("user/checkVersion", user).then(() => {
              this.$store.dispatch("init", user).then(() => {
                EventBus.$emit("hideLoading");
                this.$router.push("/installations");
              });
            });
          },
          () => {
            EventBus.$emit("hideLoading");
            this.error = true;
          }
        );
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  .buttonDisabled {
    opacity: 0.8;
  }

  .is-vertical-center {
    height: 100vh;
    background: url("/home/images/backgrounds/login.jpg") center center;

    .form {
      margin: 0 auto;
      padding: 2vw;
      width: 480px;
      max-width: 100%;

      .logo {
        width: 75%;
      }

      .title {
        font-size: 2.2em;
        text-align: center;
        color: white;
        font-weight: normal;

        span {
          font-weight: bold;
        }
      }

      .formContent {
        background: #ffffff;
        border: 1px solid gainsboro;
        padding: 0px 20px 10px;
        border-radius: 1vh;
        text-align: left;
        margin-bottom: 1.5rem;

        .formElement {
          margin: 1rem 0;

          label,
          .recoverPassword a {
            color: #9c9b9b;
            font-size: 0.8rem;
            transition: 0.2s ease-in-out color;
          }
          input {
            padding: 8px;
            display: block;
            border: none;
            border-bottom: 1px solid #9c9b9b;
            width: 100%;
            transition: 0.2s ease-in-out border;
          }
          input:focus {
            border-bottom: 1px solid #2dab66;
          }
          .recoverPassword {
            float: right;
          }
          .recoverPassword a:hover {
            color: #2dab66;
          }
        }
        .error {
          font-size: 0.8rem;
          color: #a12d2d;
          margin-bottom: 2em;
        }
      }

      button {
        background: #2dab66;
        padding: 5px 15px;
        border-radius: 1vh;
        border: none;
        color: #ffffff;
        font-size: 1.3rem;
        cursor: pointer;
        transition: 0.2s ease-in-out background;
      }
      button:hover {
        background: #2fbd6f;
      }

      .noAccount {
        color: #ffffff;
        margin-top: 10px;
        font-size: 0.8rem;

        span a {
          color: #ffffff;
          text-transform: uppercase;
          text-decoration: underline;
        }
        span a:hover {
          color: #eaeaea;
          text-transform: uppercase;
        }
      }
    }
  }
}
</style>
